import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  typescript,
  physics,
  carDash,
  github,
  Airbnb,
  iphone,
  Admin,
  videocall,
  html,
  chair,
  css,
  tdwebsite,
  reactjs,
  hexaware,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  figma,
  docker,
  meta,
  starbucks,
  black,
  paperMusic,
  tesla,
  shopify,
  carrent,
  jobit,
  tripguide,
  threejs,
  ansible,
  aws,
  kubernetes,
  linux,
  marble,
  python,
  socket,
  unity,
  jenkins,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Web Developer",
    icon: web,
  },
  {
    title: "Frontend Developer",
    icon: mobile,
  },
  {
    title: "Backend Developer",
    icon: backend,
  },
  {
    title: "Deployment",
    icon: creator,
  },
];

const technologies = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "TypeScript",
    icon: typescript,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },
  {
    name: "Three JS",
    icon: threejs,
  },
  {
    name: "git",
    icon: git,
  },
  {
    name: "socket",
    icon: socket,
  },
  {
    name: "python",
    icon: python,
  },
];

const Learningtechnologies = [
  {
    name: "docker",
    icon: docker,
  },
  {
    name: "unity",
    icon: unity,
  },
  {
    name: "ansible",
    icon: ansible,
  },
  {
    name: "AWS",
    icon: aws,
  },
  {
    name: "Kubrnetes",
    icon: kubernetes,
  },
  {
    name: "Linux",
    icon: linux,
  },
  {
    name: "jenkins",
    icon: jenkins,
  },
];

const experiences = [
  {
    title: "Co-Founder [CTO]",
    company_name: "Paper Music",
    icon: paperMusic,
    iconBg: "#000",
    date: "Jan 2018 - April 2020",
    points: [
      "As a CTO i was responsible for developing and maintaining all the complex web features and applications",
      "Build and deployed the full stack website including Lading,Admin,payment and operations",
      "Elastic development for Easy scalability and performance",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Game Developer",
    company_name: "Gama Games",
    icon: black,
    iconBg: "#E6DEDD",
    date: "May 2020 - Feb 2021",
    points: [
      "Developed two production games using UNITY over a year",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Technological hardware  implementation of the Product.",
      "Optimising and maintaining game bug fixes and overlooking Development lifecycle",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Freelancer [Part-Time]",
    company_name: "web developer",
    icon: black,
    iconBg: "#000",
    date: "Mar 2021 - Jan 2022",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Various Code reviews and Bug Fixes on the team",
      "Implementing responsive design and ensuring cross-browser compatibility.",
    ],
  },
  {
    title: "Software Engineer",
    company_name: "Hexaware Technologies",
    icon: hexaware,
    iconBg: "#E6DEDD",
    date: "Mar 2022 - Present",
    points: [
      "Core Team Memeber in building Parser for buissness logic of legacy application programming languages like COBOL,Delphi.",
      "Worked on hands on  Ai and  deep learning using transfer learning of tensorflow to build object detection and computer vison programs",
      "Generating and building Yoemen templates for Goland and React based application using EJS and Node",
      "Developed various frontend applications and microservices for internal use.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
];

const testimonials = [
  {
    testimonial:
      "I thought it was impossible to make a website as beautiful as our product, but Rick proved me wrong.",
    name: "Sara Lee",
    designation: "CFO",
    company: "Acme Co",
    image: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    testimonial:
      "I've never met a web developer who truly cares about their clients' success like Rick does.",
    name: "Chris Brown",
    designation: "COO",
    company: "DEF Corp",
    image: "https://randomuser.me/api/portraits/men/5.jpg",
  },
  {
    testimonial:
      "After Rick optimized our website, our traffic increased by 50%. We can't thank them enough!",
    name: "Lisa Wang",
    designation: "CTO",
    company: "456 Enterprises",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
  },
];

const projects = [
  {
    name: "airbnb Clone",
    description:
      "This is an airbnb clone that has all the features of listings,bookings and Search functionalities.Also has all the Auth functionalities used Next Auth",
    tags: [
      {
        name: "NextJs",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: Airbnb,
    source_code_link: "https://mohdcloneairbnb.vercel.app/",
  },
  {
    name: "Admin Dashboard",
    description:
      "This a Admin Dashboard Project with all the functionalities required for an Admin Dashboard ranging from all the charts to meetings etc",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "restapi",
        color: "green-text-gradient",
      },
    ],
    image: Admin,
    source_code_link: "https://mohds-admin-dashboard.netlify.app/",
  },
  {
    name: "3-d Ecommerce Website",
    description: "A 3-D Ecommerce Website built on React-3F",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "React-3F",
        color: "green-text-gradient",
      },
    ],
    image: tdwebsite,
    source_code_link: "https://3-d-ecommerce-store.netlify.app/",
  },
  {
    name: "Marble Game",
    description: "A Marble Game built on React-3F with physics and much more",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "React-3F",
        color: "green-text-gradient",
      },
    ],
    image: marble,
    source_code_link: "https://r-3f-marble-game-mohd.netlify.app/",
  },
  {
    name: "Iphone 3-D AD",
    description:
      "A 3-d Ad For iphone-14 following the design principles of Apple",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "React-3F",
        color: "green-text-gradient",
      },
    ],
    image: iphone,
    source_code_link: "https://apple-iphone14-3d.netlify.app/",
  },
  {
    name: "3-D Chair",
    description: "A 3-d chair project",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "React-3F",
        color: "green-text-gradient",
      },
    ],
    image: chair,
    source_code_link: "https://chair-website.netlify.app/",
  },
  {
    name: "VideoCall App",
    description: "A 3-d chair project",
    tags: [
      {
        name: "MERN",
        color: "blue-text-gradient",
      },
      {
        name: "Socket",
        color: "green-text-gradient",
      },
    ],
    image: videocall,
    source_code_link: "https://zoom-clone-umer.netlify.app/",
  },
  {
    name: "Physics 20K challenge",
    description: "A 3-d challenge project for Bruno Simons",
    tags: [
      {
        name: "React3-F",
        color: "blue-text-gradient",
      },
      {
        name: "Physics",
        color: "green-text-gradient",
      },
    ],
    image: physics,
    source_code_link: "https://physics-test-mohd.netlify.app/",
  },
  {
    name: "Car Dash [Production]",
    description: "A Production built game at Gama Games",
    tags: [
      {
        name: "Unity",
        color: "blue-text-gradient",
      },
      {
        name: "Physics",
        color: "green-text-gradient",
      },
    ],
    image: carDash,
    source_code_link:
      "https://play.google.com/store/apps/details?id=com.cardash.proto",
  },
  {
    name: "GitHub",
    description: "This a GitHub Profile to access more Projects",
    tags: [
      {
        name: "More Projects",
        color: "blue-text-gradient",
      },
    ],
    image: github,
    source_code_link: "https://github.com/mohdumer7",
  },
];

export {
  services,
  technologies,
  experiences,
  testimonials,
  projects,
  Learningtechnologies,
};
